export interface PropertyListAreaDetailAttributes {
  objectid: number
  id: number
  nespravny: string | null
  kmenovecislo: number | null
  poddelenicisla: number | null
  vymeraparcely: number | null
  zpusobyvyuzitipozemku: number | null
  druhcislovanikod: number | null
  druhpozemkukod: number | null
  katastralniuzemi: number | null
  platiod: number | null
  idtransakce: number | null
  rizeniid: number | null
  'st_area(shape)': number | null
  [k: string]: unknown
}

export const LABEL_DRUH_POZEMKU: Record<number, string> = {
  2: 'Orná půda',
  3: 'Chmelnice',
  4: 'Vinice',
  5: 'Zahrada',
  6: 'Ovocný sad',
  7: 'Trvalý travní porost',
  10: 'Lesní pozemek',
  11: 'Vodní plocha',
  13: 'Zastavěná plocha a nádvoří',
  14: 'Ostatní plocha',
}

export const LABEL_ZPUSOB_VYUZITI_POZEMKU: Record<number, string> = {
  1: 'Skleník, pařeniště',
  2: 'Školka',
  3: 'Plantáž dřevin',
  4: 'Les jiný než hospodářský',
  5: 'Lesní pozemek s budovou',
  6: 'Rybník',
  7: 'Koryto vod. toku přirozené/upravené',
  8: 'Koryto vod. toku umělé',
  9: 'Vodní nádrž přírodní',
  10: 'Vodní nádrž umělá',
  11: 'Zamokřená plocha',
  12: 'Společný dvůr',
  13: 'Zbořeniště',
  14: 'Dráha',
  15: 'Dálnice',
  16: 'Silnice',
  17: 'Ostatní komunikace',
  18: 'Ostatní dopravní plocha',
  19: 'Zeleň',
  20: 'Sportoviště a rekreační plocha',
  21: 'Pohřebiště',
  22: 'Kulturní a osvětová plocha',
  23: 'Manipulační plocha',
  24: 'Dobývací prostor',
  25: 'Skládka',
  26: 'Jiná plocha',
  27: 'Neplodná půda',
  28: 'Vodní plocha s budovou',
  29: 'Fotovoltaická elektrárna',
  30: 'Mez, stráň',
}

const getOptions = (labels: Record<number, string>) =>
  Object.entries(labels).map(([value, text]) => ({
    text,
    value: Number(value),
  }))

export const propertyListAreaDetailFilterOptions = {
  druhPozemku: getOptions(LABEL_DRUH_POZEMKU),
  zpusobVyuzitiPozemku: getOptions(LABEL_ZPUSOB_VYUZITI_POZEMKU),
}
